export const LIVING_REWARDS = "Living Rewards";